export default "__VITE_ASSET__uTaE$X_E__"